import { config } from '@config/config';
import { correspondanceBitrixToGtm, UNCOVERED_DOMAIN_ID } from '@config/lists';
import { catalog } from '@core/catalog';
import { initGTM, sendDataToGTM } from './gtm';
import { ensureMetaEventId, getMetaEventId } from './meta';

export const init = (): void => {
  initGTM(config.gtm);
  sendDataToGTM({ event: 'setMetaEventId', metaEventId: ensureMetaEventId() });
};

export const sendData = (data: Record<string, unknown>): void =>
  sendDataToGTM({ ...data, metaEventId: getMetaEventId() });

export const formatTrackingEvent = ({
  formData,
}: {
  formData: { name: string; value: string | number };
}): { event: string } & Record<string, unknown> => {
  const { name, value } = formData;
  const bitrixLabel = (
    correspondanceBitrixToGtm as Record<
      string,
      { id: number | string; name: string }[]
    >
  )[name]?.find((option) => Number(option.id) === Number(value))?.name;
  const domainLabel =
    name === 'domainId'
      ? value === UNCOVERED_DOMAIN_ID
        ? 'Autre'
        : catalog().themes.find((theme) => theme.id === value)?.name
      : undefined;
  const resolvedLabel = domainLabel ?? bitrixLabel ?? value;
  return { event: `set${name}`, [name]: resolvedLabel };
};
